"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _tinymce = _interopRequireDefault(require("tinymce"));

var _plugins = require("../constants/plugins");

var _usageTracking = require("../constants/usageTracking");

var _usageTracking2 = require("../utils/usageTracking");

var _paste = require("../utils/paste");

var _hspaste = require("../constants/hspaste");

var _utils = require("../hspaste/utils");

var _searchandreplace = require("./searchandreplace");

function usagePlugin(editor) {
  var allowEmbedUrlPasting = (0, _utils.getPastePluginSetting)(editor, _hspaste.hspasteConfig.EMBED_URL_PASTING);
  (0, _searchandreplace.trackSearchAndReplaceCommand)(editor);
  editor.on('BeforeExecCommand', function (event) {
    if (_usageTracking.COMMANDS_TO_TRACK[event.command]) {
      var action = _usageTracking.COMMANDS_TO_TRACK[event.command];
      var meta = {};

      if (event.command === 'mceToggleFormat') {
        meta = {
          value: event.value
        };
      }

      (0, _usageTracking2.trackInteraction)(editor, 'tinymceCommand', action, meta);
    }
  });
  Object.keys(_usageTracking.EVENTS_TO_TRACK).forEach(function (eventToTrack) {
    editor.on(eventToTrack, function (event) {
      var action = _usageTracking.EVENTS_TO_TRACK[eventToTrack];
      var meta = {
        version: 'v1'
      };

      if (eventToTrack === 'paste') {
        var _getPasteInfo = (0, _paste.getPasteInfo)(event, editor, {
          allowEmbedUrlPasting: allowEmbedUrlPasting
        }),
            type = _getPasteInfo.type,
            pasteSource = _getPasteInfo.pasteSource;

        (0, _usageTracking2.trackInteraction)(editor, 'tinymcePaste', action, (0, _extends2.default)({}, meta, {
          type: type,
          pasteSource: pasteSource
        }));
      } else {
        (0, _usageTracking2.trackInteraction)(editor, 'tinymceEvent', action, meta);
      }
    });
  });
}

_tinymce.default.PluginManager.add(_plugins.HS_USAGE, usagePlugin);